import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import AttachFilesContractWidget from '../../../widgets/attachfiles/AttachFilesContractWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getContractAttachment } from '../../../redux/actions/contract'

export default function ManagerContractAttachments() {
  //ขั้นที่ 2 ตรวจสอบสัญญาและไฟล์แนบ
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getContractAttachment(projectVersionId)
      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={8}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />
        {schema && (
          <>
            <AttachFilesContractWidget schema={schema?.forms?.contractFile} isContractFile={true} />

            <AttachFilesContractWidget schema={schema?.forms?.attachmentGrantee} />
          </>
        )}
        <br />
      </SidebarProposal>
    </>
  )
}
